import { addDays, endOfWeek, isAfter, startOfWeek, subDays } from "date-fns";

// Shared style objects
export const styles = {
  container: {
    width: "85%",
    position: "absolute",
    zIndex: "100",
    right: "26px",
    top: "100px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
  },
  totalDisplay: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    padding: "10px",
    borderRadius: "8px",
    color: "#F26B39",
    border: "1px solid #F26B39",
  },
  filterContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  selectContainer: {
    width: "200px",
  },
  chartContainer: {
    background: "white",
    padding: "20px 20px 30px 20px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    height: "calc(100vh - 20vh)",
    position: "relative",
    overflow: "visible",
  },
};

// Custom styles for dropdown
export const dropdownCustomStyles = {
  option: (base, { isDisabled, isFocused }) => {
    return {
      ...base,
      background: isFocused
        ? "rgba(242, 102, 57, 0.7)"
        : isDisabled
        ? "rgb(255,255,255)"
        : "transparent",
      color: isFocused ? "white" : "black",
      ":active": {
        backgroundColor: "rgba(242, 102, 57, 0.7)",
      },
    };
  },
};

// Date range picker predefined ranges
export const predefinedDateRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
    placement: "left",
  },
  {
    label: "Yesterday",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: "left",
  },
  {
    label: "This week",
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
    placement: "left",
  },
  {
    label: "Last 30 days",
    value: [subDays(new Date(), 29), new Date()],
    placement: "left",
  },
  {
    label: "Last week",
    closeOverlay: false,
    value: (value, index) => {
      const [start = new Date()] = value[index] || [];
      return [
        addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
        addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
      ];
    },
    appearance: "default",
  },
  {
    label: "Next week",
    closeOverlay: false,
    value: (value, index) => {
      const [start = new Date()] = value[index] || [];
      return [
        addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
        addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
      ];
    },
    appearance: "default",
  },
];

// Format amount as Indian Rupees
export const formatInRupees = (value) => {
  return value.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
  });
};

// Utility to format date
export const formatDate = (date) => date.toISOString().slice(0, 10);

// Default date range - one year ago to today
export const getDefaultDateRange = () => {
  const today = new Date();
  const startDate = new Date("2025-04-09");
  return [formatDate(startDate), formatDate(today)];
};

// Helper to handle date changes for date range picker
export const handleDateChange = (setrange, e) => {
  if (e) {
    setrange([]); // Reset range before updating
    const timezoneOffset = new Date().getTimezoneOffset() * 60000; // Offset in milliseconds

    e.forEach((newValue) => {
      const localISOTime = new Date(newValue - timezoneOffset)
        .toISOString()
        .slice(0, -1);

      // Add formatted date to range
      setrange((oldArray) => [...oldArray, localISOTime.slice(0, 10)]);
    });
  }
};
